import {
  wantedConstants
} from '../_constants';
import _ from 'lodash';
export function wanted(state = {
  gpsInformationList: [],
  newsList: []
}, action) {
  switch (action.type) {
    case wantedConstants.SAVE_WANTEDTYPE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case wantedConstants.SAVE_WANTEDTYPE_SUCCESS:
      return {
        ...state,
        isUpdated: true,
        loading: false,
        wantedtype: action.wantedtype
      };
    case wantedConstants.SAVE_WANTEDTYPE_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case wantedConstants.GET_WANTEDTYPE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case wantedConstants.GET_WANTEDTYPE_SUCCESS:
      return {
        ...state,
        isUpdated: true,
        loading: false,
        wantedType: action.wantedType
      };
    case wantedConstants.GET_WANTEDTYPE_FAILURE:
      return {
        ...state,
        error: action.error
      };




    case wantedConstants.UPDATE_WANTEDTYPE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case wantedConstants.UPDATE_WANTEDTYPE_SUCCESS:

      return {
        ...state,
        isUpdated: true,
        loading: false,
        wantedType: state.wantedType
      };
    case wantedConstants.UPDATE_WANTEDTYPE_FAILURE:
      return {
        ...state,
        error: action.error
      };

    case wantedConstants.GET_WANTED_REQUEST:
      return {
        loading: true
      };
    case wantedConstants.GET_WANTED_SUCCESS:
      return {
        getWanted: action.getWanted.pc_wantedtype,
        loading: false,
      };
    case wantedConstants.GET_WANTED_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case wantedConstants.GET_WANTED_BY_ID_REQUEST:
      return {
        ...state,
        loading: true
      };
    case wantedConstants.GET_WANTED_BY_ID_SUCCESS:
      return {
        ...state,
        wantedViewList: action.wantedViewList,
        loading: false,
      };
    case wantedConstants.GET_WANTED_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };


    /** save mobile state */

    case wantedConstants.SAVE_MOBILE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case wantedConstants.SAVE_MOBILE_SUCCESS:
      return {
        ...state,
        loading: false,
        mobile: action.mobile
      };
    case wantedConstants.SAVE_MOBILE_FAILURE:
      return {
        ...state,
        error: action.error
      };

    /** save SAVE_VEHICLE_REQUEST state */

    case wantedConstants.SAVE_VEHICLE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case wantedConstants.SAVE_VEHICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        vehicle: action.vehicle
      };
    case wantedConstants.SAVE_VEHICLE_FAILURE:
      return {
        ...state,
        error: action.error
      };


    /** save SAVE_LICENSE_REQUEST state */

    case wantedConstants.SAVE_LICENSE_REQUEST:
      return {
        ...state,
        loading: true
      };
    case wantedConstants.SAVE_LICENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        license_number: action.license_number
      };
    case wantedConstants.SAVE_LICENSE_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state
  }
}